import { render, staticRenderFns } from "./billDetail.vue?vue&type=template&id=62054d14&scoped=true"
import script from "./billDetail.vue?vue&type=script&lang=js"
export * from "./billDetail.vue?vue&type=script&lang=js"
import style0 from "./billDetail.vue?vue&type=style&index=0&id=62054d14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62054d14",
  null
  
)

export default component.exports